import { useState, useContext } from 'react';
import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonItem, IonLabel, IonButton, useIonViewDidEnter } from '@ionic/react';
import Navbar from '../../components/Navbar';
import axios from 'axios';
import './Tenants.css';
import { AppContext } from "../../context/appContext";
import { ServerUrl } from '../../constants';

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  
  const dataUrl = `${ServerUrl}/tenants`;

  const [TenantData, SetTenantData] = useState<Array<any>>([]);

  useIonViewDidEnter(() => {
    axios.get(`${dataUrl}`, {
      headers: {
        'Authorization': "Token " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetTenantData(res.data);
      }
  }, err => {
    alert("Fail to get data. " + JSON.stringify(err))
  });
  });

  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Blank</IonTitle>
          </IonToolbar>
        </IonHeader>
        <div className="container">
          <div className='block'>
            <strong>Score Card Homepage</strong>
          </div>
          <div className='block'>
            <div>Tenants list here {dataUrl}</div>
            <div>{JSON.stringify(TenantData)}</div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
